import React from 'react';

import { TableRow, TableCell } from '@material-ui/core'

import { BlacklistBookingsOptions } from 'components'
import { currencyMaker } from 'services/helpers'

export const BlacklistBooking = props => {
  const { from, to, phone, name, surname, price, fromCityTypeByLabel, sourceId, note } = props

  const currency = currencyMaker(fromCityTypeByLabel, price, sourceId)

  return (
    <TableRow>
      <TableCell padding='dense'>
        <BlacklistBookingsOptions booking={props} />
      </TableCell>

      <TableCell padding='dense'>
        {props.index + 1}
      </TableCell>

      <TableCell padding='dense'>
        {from}
      </TableCell>

      <TableCell padding='dense'>
        {to}
      </TableCell>

      <TableCell padding='dense'>
        {surname}
      </TableCell>

      <TableCell padding='dense'>
        {name}
      </TableCell>

      <TableCell padding='dense'>
        {phone}
      </TableCell>

      <TableCell padding='dense'>
        {price} {currency}
      </TableCell>

      <TableCell padding='dense'>
        {note}
      </TableCell>
    </TableRow>
  )
}



// WEBPACK FOOTER //
// ./src/components/BlacklistBookings/components/BlackistBooking/BlacklistBooking.js